<template>
  <div v-if="showComponent">
    <div class="vx-row mt-4">
      <!-- Motivo do Evento -->
      <div class="vx-col lg:w-1/2 xl:w-1/3 w-full mb-2">
        <label for="" class="vs-select--label">Motivo do Sinistro</label>
        <v-select
          :options="listMotivos"
          name="Tipo Evento"
          id="Tipo Evento"
          v-model="formDadosGerais.idTipoEvento"
          label="label"
          :reduce="(item) => item.id"
          @option:selected="selectMotivoEvento($event)"
        ></v-select>
      </div>

      <!-- Envolvimento -->
      <div class="vx-col lg:w-1/2 xl:w-1/3 w-full mb-2">
        <label for="" class="vs-select--label">Envolvimento</label>
        <v-select
          :options="listEnvolvimentos"
          name="Envolvimento"
          id="Envolvimento"
          v-model="formDadosGerais.idEnvolvimento"
          label="label"
          :reduce="(item) => item.id"
          @option:selected="selectEnvolvimento($event)"
        ></v-select>
      </div>

      <!-- Data e Hora Evento -->
      <div class="vx-col xl:w-1/3 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Sinistro</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataEvento"
              placeholder="DD/MM/AAAA"
              name="Data do Evento"
            />
          </div>
        </div>

        <!-- Hora do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Sinistro</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerHour"
              v-model="formDadosGerais.horaEvento"
              placeholder="HH:MM"
              name="Hora do Evento"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Data e Hora Comunicação Evento -->
      <div class="vx-col xl:w-1/4 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data Comunic. Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Comunicação</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataComunicacaoEvento"
              placeholder="DD/MM/AAAA"
              name="Data de Comunicação do Evento"
            />
          </div>
        </div>

        <!-- Hora Comunic. Evento -->
        <div class="xl:w-1/2 w-full">
          <div class="inputData">
            <label class="vs-input--label">Hora Comunicação</label>
            <flat-pickr
              :config="configdateTimePickerHour"
              v-model="formDadosGerais.horaComunicacaoEvento"
              placeholder="HH:MM"
              name="Hora de Comunicação do Evento"
            />
          </div>
        </div>
      </div>

      <!-- Contato, Data e Hora Contato Assistência -->
      <div class="vx-col xl:w-1/2 w-full lg:flex lg:gap-5 mb-2">
        <!-- Contato com Assistência -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Contato com Assistência</label>
          <vs-switch
            v-model="formDadosGerais.contatoAssistencia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Data Contato Assistência -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Contato Assistência</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataContatoAssistencia"
              placeholder="DD/MM/AAAA"
              name="Data de Contato da Assistência"
              :disabled="!formDadosGerais.contatoAssistencia"
            />
          </div>
        </div>

        <!-- Hora Contato Assistência -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Contato Assistência</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerHour"
              v-model="formDadosGerais.horaContatoAssistencia"
              placeholder="HH:MM"
              name="Hora de Contato da Assistência"
              :disabled="!formDadosGerais.contatoAssistencia"
            />
          </div>
        </div>
      </div>

      <!-- Data e Hora Previsão Entrega -->
      <div class="vx-col xl:w-1/4 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data Previsão Entrega -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Prev. Entrega</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataPrevisaoEntrega"
              placeholder="DD/MM/AAAA"
              name="Data de Previsão de Entrega"
            />
          </div>
        </div>

        <!-- Hora Previsão Entrega -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Prev. Entrega</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerHour"
              v-model="formDadosGerais.horaPrevisaoEntrega"
              placeholder="HH:MM"
              name="Hora de Previsão de Entrega"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Acionamento p/ terceiro -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Acionamento p/ terceiro</label>
        <vs-switch
          v-model="formDadosGerais.acionamentoParaTerceiro"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Veículo em locomoção -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Veículo em locomoção</label>
        <vs-switch
          v-model="formDadosGerais.veiculoEmLocomocao"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Sindicante no local -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Sindicante no local</label>
        <vs-switch
          v-model="formDadosGerais.sindicanteNoLocal"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Polícia Compareceu -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Polícia Compareceu</label>
        <vs-switch
          v-model="formDadosGerais.policiaCompareceu"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Veículo em Oficina -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Veículo em Oficina</label>
        <vs-switch
          v-model="formDadosGerais.veiculoEmOficina"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Houve vítima? -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Houve vítima?</label>
        <vs-switch
          v-model="formDadosGerais.possuiVitima"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Número Boletim de Ocorrência -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número Boletim de Ocorrência"
          name="Número Boletim de Ocorrência"
          v-model="formDadosGerais.numeroBoletim"
        />
      </div>

      <!-- Data Registro BO -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <label class="vs-input--label">Data Registro BO</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePickerDay"
            v-model="formDadosGerais.dataBoletim"
            placeholder="DD/MM/AAAA"
            name="Data Registro BO"
          />
        </div>
      </div>

      <!-- Hora Registro BO -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <label class="vs-input--label">Hora Registro BO</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePickerHour"
            v-model="formDadosGerais.horaBoletim"
            placeholder="HH:MM"
            name="Hora Registro BO"
          />
        </div>
      </div>

      <!-- Órgão Responsável -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Órgão Responsável"
          name="Órgão Responsável"
          v-model="formDadosGerais.orgaoRegistroBoletim"
        />
      </div>
    </div>

    <!-- Relato do Boletim de Ocorrência -->
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vs-textarea
          label="Relato do Boletim de Ocorrência"
          v-model="formDadosGerais.descricaoBoletim"
        />
      </div>
    </div>

    <div class="vx-row">
      <!-- Id Externo -->
      <div class="vx-col lg:w-1/2 w-full mb-2">
        <vs-input
          class="w-full"
          label="Id Externo"
          name="Id Externo"
          v-model="formDadosGerais.idExterno"
        />
      </div>
    </div>

    <!-- Descrição do Evento para controle externo -->
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vs-textarea
          label="Descrição do Evento para controle externo"
          v-model="formDadosGerais.descricaoEventoControleExterno"
        />
      </div>
    </div>

    <!-- REMOVIDO TEMPORARIAMENTE -->
    <!-- Observaçõe -->
    <!-- <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <span class="vs-input--label">Observações</span>
        <vue-editor
          v-model="formDadosGerais.observacao"
          :editor-toolbar="customToolbar"
        ></vue-editor>
      </div>
    </div>

    <HistoricoObservacao :historicos="formDadosGerais.historicos" /> -->
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import customToolbar from './../../../../../../../components/editor/config';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (!value.dadosGerais) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - DADOS GERAIS FORM');
        return;
      }

      this.formDadosGerais = Object.assign(
        this.formDadosGerais,
        value.dadosGerais,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.dadosGerais = this.formDadosGerais;
    },
  },
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      showComponent: true,
      formDadosGerais: {
        idTipoEvento: null,
        descricaoTipoEvento: null,
        idStatus: null,
        idEnvolvimento: null,
        descricaoEnvolvimento: null,
        dataEvento: null,
        horaEvento: null,
        dataHoraEvento: null,
        dataComunicacaoEvento: null,
        horaComunicacaoEvento: null,
        dataHoraComunicacaoEvento: null,
        dataContatoAssistencia: null,
        horaContatoAssistencia: null,
        dataHoraContatoAssistencia: null,
        dataPrevisaoEntrega: null,
        horaPrevisaoEntrega: null,
        dataHoraPrevisaoEntrega: null,
        contatoAssistencia: null,
        acionamentoParaTerceiro: null,
        veiculoEmLocomocao: null,
        sindicanteNoLocal: null,
        policiaCompareceu: null,
        veiculoEmOficina: null,
        possuiVitima: null,
        numeroBoletim: null,
        dataBoletim: null,
        horaBoletim: null,
        dataHoraBoletim: null,
        orgaoRegistroBoletim: null,
        descricaoBoletim: null,
        idExterno: null,
        idUsuario: null,
        observacao: null,
        descricaoEventoControleExterno: null,
        historicos: [],
      },
      listMotivos: [],
      listEnvolvimentos: [],

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
      customToolbar,
    };
  },
  methods: {
    selectMotivoEvento(value) {
      this.formDadosGerais.descricaoTipoEvento = value.label;
    },
    selectEnvolvimento(value) {
      this.formDadosGerais.descricaoEnvolvimento = value.label;
    },
  },
  mounted() {
    if (!this.formData.dadosGerais) {
      console.error('ERRO NO CONTRATO DO OBJETO - DADOS GERAIS FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosGerais = this.formDadosGerais;

    if (this.dominios) {
      this.listMotivos = this.dominios.listMotivos;
      this.listEnvolvimentos = this.dominios.listEnvolvimentos;
    }
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}

.vx-row.divider {
  border: 0.5px solid rgba(0, 0, 0, 0.08);
}
</style>

<style src="./../../../../../../../components/editor/style-editor.css"></style>
